// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries




// JOEL ERULU

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCkVeZnhboBJt8zc6GYbMPbQJi7IMxIdL4",
  authDomain: "workshop-cfd00.firebaseapp.com",
  projectId: "workshop-cfd00",
  storageBucket: "workshop-cfd00.appspot.com",
  messagingSenderId: "589947610599",
  appId: "1:589947610599:web:be20afa2855082138f0942",
  measurementId: "G-2NTH5F9SSL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
